/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewtolabel3Inputs */

const en_letterpreviewtolabel3 = /** @type {(inputs: Letterpreviewtolabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

const pt_letterpreviewtolabel3 = /** @type {(inputs: Letterpreviewtolabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para`)
};

/**
* | output |
* | --- |
* | "To" |
*
* @param {Letterpreviewtolabel3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewtolabel3 = /** @type {((inputs?: Letterpreviewtolabel3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewtolabel3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewtolabel3(inputs)
	return pt_letterpreviewtolabel3(inputs)
});
export { letterpreviewtolabel3 as "letterPreviewToLabel" }